export default __webpack_public_path__ + "locales/vi/Notifications.json?hash=f703412909ac7b2c72b3b20d0714d9a4";